import { FC } from 'react'
import { useMantineTheme } from '@mantine/core'

import { GeographicCoordinates } from '@/api/main/types.gen'
import { MapScaleFunction } from '@/utils/svg'

const VehiclePositionOverlay: FC<{
  position?: GeographicCoordinates
  azimuth?: number
  scaleFnc: MapScaleFunction
  variant?: 'normal' | 'warning'
}> = ({ position, azimuth, scaleFnc, variant = 'normal' }) => {
  const theme = useMantineTheme()

  if (!position) {
    return null
  }

  const [x, y] = scaleFnc([position.latitude, position.longitude])

  return (
    <>
      <circle
        cx={x}
        cy={y}
        r={24}
        style={{
          fill: variant === 'warning' ? theme.colors.red[9] : theme.colors.orange[4],
          fillOpacity: variant === 'warning' ? 0.4 : 1,
        }}
      />
      <polygon
        transform={`rotate(${azimuth ?? 0} ${x} ${y})`}
        style={{ fill: theme.colors.gray[0] }}
        points={[
          [x, y],
          [x + 16, y + 14],
          [x, y - 18],
          [x - 16, y + 14],
          [x, y],
        ]
          .map(it => it.join(','))
          .join(' ')}
      />
    </>
  )
}

export default VehiclePositionOverlay
